import axios from 'axios';

const altchaApi = axios.create({
  baseURL: process.env.CAPCTHA_SERVICE_URL,
  timeout: 10000,
  headers: {
    'Accept': 'application/json'
  }
});

export const loadAltcha = () => {
  return altchaApi.get('/altcha');
};



// WEBPACK FOOTER //
// ./src/js/services/integrations-internas/captcha.js